var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.schedulePeriods.length === 0
    ? _c(
        "v-container",
        { staticClass: "schedule", attrs: { fluid: "", "fill-height": "" } },
        [
          _c(
            "portal",
            { attrs: { to: "page-title" } },
            [
              _c(
                "v-container",
                { staticClass: "schedule-header py-0 mx-0" },
                [
                  _c(
                    "v-row",
                    { attrs: { justify: "space-between" } },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pl-0",
                          attrs: { "align-self": "center", cols: "auto" }
                        },
                        [
                          _c(
                            "v-row",
                            { staticClass: "ml-1", attrs: { align: "center" } },
                            [_c("DepartmentSelector")],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-spacer")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            {
              staticStyle: { "margin-top": "-150px" },
              attrs: { justify: "center" }
            },
            [
              _c("v-col", { attrs: { md: "6", sm: "12" } }, [
                _c(
                  "div",
                  { staticClass: "mt-10 mx-3 pa-6" },
                  [
                    _c(
                      "v-row",
                      { attrs: { justify: "center" } },
                      [
                        _c("v-img", {
                          attrs: {
                            contain: "",
                            "max-width": "50%",
                            src: require("@/assets/images/oops-penguin.svg")
                          }
                        })
                      ],
                      1
                    ),
                    _c("div", {
                      staticClass:
                        "darken-2 grey--text mt-5 px-5 text--darken-3 text-center ",
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("descriptions.noSchedules"))
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    : _c(
        "v-container",
        { staticClass: "schedule", attrs: { fluid: "" } },
        [
          _vm.retrievingSchedule &&
          !_vm.gridInitialized &&
          _vm.showSkeletonLoader
            ? [
                _c(
                  "v-container",
                  { staticClass: "schedule", attrs: { fluid: "" } },
                  [
                    _c(
                      "v-row",
                      { attrs: { dense: "" } },
                      [
                        _vm.$vuetify.breakpoint.smAndDown
                          ? _vm._l(2, function(n) {
                              return _c(
                                "v-col",
                                { key: n, attrs: { cols: "auto" } },
                                [
                                  _c("v-skeleton-loader", {
                                    staticClass: "single-action",
                                    attrs: { type: "actions" }
                                  })
                                ],
                                1
                              )
                            })
                          : _vm._l(5, function(n) {
                              return _c(
                                "v-col",
                                { key: n, attrs: { cols: "auto" } },
                                [
                                  _c("v-skeleton-loader", {
                                    staticClass: "single-action",
                                    attrs: { type: "actions" }
                                  })
                                ],
                                1
                              )
                            }),
                        _c("v-spacer")
                      ],
                      2
                    ),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12" } },
                          [
                            _c("v-skeleton-loader", {
                              staticClass: "no-action",
                              attrs: { type: "table" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : !_vm.retrievingSchedule
            ? [
                _c(
                  "v-container",
                  {
                    staticClass: "schedule",
                    style: _vm.gridMaxWidth,
                    attrs: { fluid: "" }
                  },
                  [
                    _c(
                      "portal",
                      { attrs: { to: "page-title" } },
                      [
                        _vm.$vuetify.breakpoint.width < 600
                          ? [
                              _c(
                                "v-container",
                                { staticClass: "schedule-header py-0" },
                                [
                                  _c(
                                    "v-row",
                                    { attrs: { justify: "space-between" } },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pl-0",
                                          attrs: {
                                            "align-self": "center",
                                            cols: "auto"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "ml-1",
                                              attrs: { align: "center" }
                                            },
                                            [_c("DepartmentSelector")],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c("v-spacer"),
                                      !_vm.scheduleIsReadOnly ||
                                      _vm.scheduleIsReadyToPublish ||
                                      _vm.needsReview
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "px-0",
                                              attrs: {
                                                "align-self": "center",
                                                cols: "auto"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-menu",
                                                {
                                                  attrs: {
                                                    "min-width": "200",
                                                    "offset-y": ""
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function(ref) {
                                                          var on = ref.on
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                {
                                                                  staticClass:
                                                                    "mx-1 account-icon",
                                                                  attrs: {
                                                                    icon: "",
                                                                    small: ""
                                                                  }
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "\n                        fal fa-ellipsis-v\n                      "
                                                                  )
                                                                ])
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    false,
                                                    2787313602
                                                  )
                                                },
                                                [
                                                  _c(
                                                    "v-list",
                                                    [
                                                      _vm.scheduleIsInitial &&
                                                      _vm.$store.state.org
                                                        .settings.scheduling
                                                        .nurseSelfSchedule
                                                        .alwaysOpen
                                                        ? _c(
                                                            "v-list-item",
                                                            {
                                                              staticClass:
                                                                "caption",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.postingScheduleForSelfSchedule,
                                                                title: _vm.$t(
                                                                  "labels.postForSelfSchedule"
                                                                )
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.preventDefault()
                                                                  return _vm.postScheduleForSelfSchedule.apply(
                                                                    null,
                                                                    arguments
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-action",
                                                                [
                                                                  _vm.postingScheduleForSelfSchedule
                                                                    ? _c(
                                                                        "v-progress-circular",
                                                                        {
                                                                          attrs: {
                                                                            color:
                                                                              "primary lighten-2",
                                                                            indeterminate:
                                                                              "",
                                                                            size:
                                                                              "16",
                                                                            width:
                                                                              "2"
                                                                          }
                                                                        }
                                                                      )
                                                                    : _c(
                                                                        "v-icon",
                                                                        {
                                                                          attrs: {
                                                                            small:
                                                                              ""
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                          fal fa-calendar-edit\n                        "
                                                                          )
                                                                        ]
                                                                      )
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-list-item-title",
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "labels.postForSelfSchedule"
                                                                        )
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm.scheduleIsDraft
                                                        ? _c(
                                                            "v-list-item",
                                                            {
                                                              staticClass:
                                                                "caption",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.postingSchedule,
                                                                title: _vm.$t(
                                                                  "labels.postDraft"
                                                                )
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.preventDefault()
                                                                  return _vm.postSchedule.apply(
                                                                    null,
                                                                    arguments
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-action",
                                                                [
                                                                  _vm.postingSchedule
                                                                    ? _c(
                                                                        "v-progress-circular",
                                                                        {
                                                                          attrs: {
                                                                            color:
                                                                              "primary lighten-2",
                                                                            indeterminate:
                                                                              "",
                                                                            size:
                                                                              "16",
                                                                            width:
                                                                              "2"
                                                                          }
                                                                        }
                                                                      )
                                                                    : _c(
                                                                        "v-icon",
                                                                        {
                                                                          attrs: {
                                                                            small:
                                                                              ""
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                          fal fa-paper-plane\n                        "
                                                                          )
                                                                        ]
                                                                      )
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-list-item-title",
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "labels.postDraft"
                                                                        )
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm.scheduleIsReadyToPublish
                                                        ? _c(
                                                            "v-list-item",
                                                            {
                                                              staticClass:
                                                                "caption",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.publishingSchedule,
                                                                title: _vm.$t(
                                                                  "labels.publishSchedule"
                                                                )
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  $event.preventDefault()
                                                                  return _vm.publishSchedule.apply(
                                                                    null,
                                                                    arguments
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item-action",
                                                                [
                                                                  _vm.publishingSchedule
                                                                    ? _c(
                                                                        "v-progress-circular",
                                                                        {
                                                                          attrs: {
                                                                            color:
                                                                              "primary lighten-2",
                                                                            indeterminate:
                                                                              "",
                                                                            size:
                                                                              "16",
                                                                            width:
                                                                              "2"
                                                                          }
                                                                        }
                                                                      )
                                                                    : _c(
                                                                        "v-icon",
                                                                        {
                                                                          attrs: {
                                                                            small:
                                                                              ""
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                          fal fa-paper-plane\n                        "
                                                                          )
                                                                        ]
                                                                      )
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-list-item-title",
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "labels.publishSchedule"
                                                                        )
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm.needsReview
                                                        ? [
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticClass:
                                                                  "caption",
                                                                attrs: {
                                                                  disabled:
                                                                    _vm.approvingSchedule ||
                                                                    _vm.rejectingSchedule,
                                                                  title: _vm.$t(
                                                                    "labels.reject"
                                                                  )
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.rejectSchedule.apply(
                                                                      null,
                                                                      arguments
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-action",
                                                                  [
                                                                    _vm.rejectingSchedule
                                                                      ? _c(
                                                                          "v-progress-circular",
                                                                          {
                                                                            attrs: {
                                                                              color:
                                                                                "primary lighten-2",
                                                                              indeterminate:
                                                                                "",
                                                                              size:
                                                                                "16",
                                                                              width:
                                                                                "2"
                                                                            }
                                                                          }
                                                                        )
                                                                      : _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs: {
                                                                              color:
                                                                                "error",
                                                                              small:
                                                                                ""
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                            fas fa-times-circle\n                          "
                                                                            )
                                                                          ]
                                                                        )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-list-item-title",
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "labels.reject"
                                                                          )
                                                                        ) +
                                                                        "\n                        "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticClass:
                                                                  "caption",
                                                                attrs: {
                                                                  disabled:
                                                                    _vm.approvingSchedule ||
                                                                    _vm.rejectingSchedule,
                                                                  title: _vm.$t(
                                                                    "labels.approve"
                                                                  )
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.approveSchedule.apply(
                                                                      null,
                                                                      arguments
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-action",
                                                                  [
                                                                    _vm.approvingSchedule
                                                                      ? _c(
                                                                          "v-progress-circular",
                                                                          {
                                                                            attrs: {
                                                                              color:
                                                                                "primary lighten-2",
                                                                              indeterminate:
                                                                                "",
                                                                              size:
                                                                                "16",
                                                                              width:
                                                                                "2"
                                                                            }
                                                                          }
                                                                        )
                                                                      : _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs: {
                                                                              color:
                                                                                "success",
                                                                              small:
                                                                                ""
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                            fas fa-check-circle\n                          "
                                                                            )
                                                                          ]
                                                                        )
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-list-item-title",
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "labels.approve"
                                                                          )
                                                                        ) +
                                                                        "\n                        "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        : _vm._e(),
                                                      _c(
                                                        "v-list-item",
                                                        {
                                                          on: {
                                                            click:
                                                              _vm.toggleHelpPanel
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item-action",
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    small: ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                          fal fa-info-circle\n                        "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-list-item-title",
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "labels.information"
                                                                    )
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    2
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _c(
                                            "v-col",
                                            {
                                              staticClass: "px-0",
                                              attrs: {
                                                "align-self": "center",
                                                cols: "auto"
                                              }
                                            },
                                            [
                                              _c(
                                                "v-menu",
                                                {
                                                  attrs: {
                                                    "min-width": "200",
                                                    "offset-y": ""
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function(ref) {
                                                          var on = ref.on
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                {
                                                                  staticClass:
                                                                    "mx-1",
                                                                  attrs: {
                                                                    icon: "",
                                                                    small: ""
                                                                  }
                                                                },
                                                                on
                                                              ),
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "\n                        fal fa-ellipsis-v\n                      "
                                                                  )
                                                                ])
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    false,
                                                    4004589445
                                                  )
                                                },
                                                [
                                                  _c(
                                                    "v-list",
                                                    [
                                                      _c(
                                                        "v-list-item",
                                                        {
                                                          on: {
                                                            click:
                                                              _vm.toggleHelpPanel
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item-action",
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    small: ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                          fal fa-info-circle\n                        "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-list-item-title",
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "labels.information"
                                                                    )
                                                                  ) +
                                                                  "\n                      "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          : [
                              _c(
                                "v-row",
                                {
                                  staticClass: "schedule-header",
                                  attrs: { justify: "space-between" }
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        "align-self": "center",
                                        cols: "auto"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "ml-1",
                                          attrs: { align: "center" }
                                        },
                                        [_c("DepartmentSelector")],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  !_vm.scheduleIsReadOnly ||
                                  _vm.scheduleIsReadyToPublish ||
                                  _vm.needsReview
                                    ? _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            "align-self": "center",
                                            cols: "auto"
                                          }
                                        },
                                        [
                                          _vm.scheduleIsInitial &&
                                          _vm.$store.state.org.settings
                                            .scheduling.nurseSelfSchedule
                                            .alwaysOpen
                                            ? _c(
                                                "v-tooltip",
                                                {
                                                  attrs: {
                                                    bottom: "",
                                                    "nudge-top": "10"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function(ref) {
                                                          var tooltipOn = ref.on
                                                          var attrs = ref.attrs
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                _vm._b(
                                                                  {
                                                                    staticClass:
                                                                      "post-draft mr-2",
                                                                    attrs: {
                                                                      color:
                                                                        "secondary",
                                                                      disabled:
                                                                        _vm.postingScheduleForSelfSchedule,
                                                                      text:
                                                                        _vm
                                                                          .$vuetify
                                                                          .breakpoint
                                                                          .lgAndUp,
                                                                      icon:
                                                                        _vm
                                                                          .$vuetify
                                                                          .breakpoint
                                                                          .mdAndDown,
                                                                      title: _vm.$t(
                                                                        "labels.postForSelfSchedule"
                                                                      )
                                                                    }
                                                                  },
                                                                  "v-btn",
                                                                  attrs,
                                                                  false
                                                                ),
                                                                Object.assign(
                                                                  {},
                                                                  tooltipOn,
                                                                  {
                                                                    click:
                                                                      _vm.postScheduleForSelfSchedule
                                                                  }
                                                                )
                                                              ),
                                                              [
                                                                _vm.postingScheduleForSelfSchedule
                                                                  ? _c(
                                                                      "v-progress-circular",
                                                                      {
                                                                        attrs: {
                                                                          color:
                                                                            "primary lighten-2",
                                                                          indeterminate:
                                                                            "",
                                                                          size:
                                                                            "22",
                                                                          width:
                                                                            "2"
                                                                        }
                                                                      }
                                                                    )
                                                                  : _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          size:
                                                                            "20"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                      fas fa-calendar-edit\n                    "
                                                                        )
                                                                      ]
                                                                    ),
                                                                _vm.$vuetify
                                                                  .breakpoint
                                                                  .lgAndUp
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "ml-2"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                      " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "labels.postForSelfSchedule"
                                                                              )
                                                                            ) +
                                                                            "\n                    "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    false,
                                                    2759953002
                                                  )
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "body-2" },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "labels.postForSelfSchedule"
                                                            )
                                                          ) +
                                                          "\n                "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.scheduleIsDraft
                                            ? _c(
                                                "v-tooltip",
                                                {
                                                  attrs: {
                                                    bottom: "",
                                                    "nudge-top": "10"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function(ref) {
                                                          var tooltipOn = ref.on
                                                          var attrs = ref.attrs
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                _vm._b(
                                                                  {
                                                                    staticClass:
                                                                      "post-draft mr-2",
                                                                    attrs: {
                                                                      color:
                                                                        "primary",
                                                                      disabled:
                                                                        _vm.postingSchedule,
                                                                      text:
                                                                        _vm
                                                                          .$vuetify
                                                                          .breakpoint
                                                                          .lgAndUp,
                                                                      icon:
                                                                        _vm
                                                                          .$vuetify
                                                                          .breakpoint
                                                                          .mdAndDown,
                                                                      title: _vm.$t(
                                                                        "labels.postDraft"
                                                                      )
                                                                    }
                                                                  },
                                                                  "v-btn",
                                                                  attrs,
                                                                  false
                                                                ),
                                                                Object.assign(
                                                                  {},
                                                                  tooltipOn,
                                                                  {
                                                                    click:
                                                                      _vm.postSchedule
                                                                  }
                                                                )
                                                              ),
                                                              [
                                                                _vm.postingSchedule
                                                                  ? _c(
                                                                      "v-progress-circular",
                                                                      {
                                                                        attrs: {
                                                                          color:
                                                                            "primary lighten-2",
                                                                          indeterminate:
                                                                            "",
                                                                          size:
                                                                            "22",
                                                                          width:
                                                                            "2"
                                                                        }
                                                                      }
                                                                    )
                                                                  : _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          size:
                                                                            "20"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                      fas fa-paper-plane\n                    "
                                                                        )
                                                                      ]
                                                                    ),
                                                                _vm.$vuetify
                                                                  .breakpoint
                                                                  .lgAndUp
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "ml-2"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                      " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "labels.post"
                                                                              )
                                                                            ) +
                                                                            "\n                    "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    false,
                                                    564789141
                                                  )
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "body-2" },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "labels.post"
                                                            )
                                                          ) +
                                                          "\n                "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.scheduleIsReadyToPublish
                                            ? _c(
                                                "v-tooltip",
                                                {
                                                  attrs: {
                                                    bottom: "",
                                                    "nudge-top": "10"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function(ref) {
                                                          var tooltipOn = ref.on
                                                          var attrs = ref.attrs
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                _vm._b(
                                                                  {
                                                                    staticClass:
                                                                      "publish-schedule",
                                                                    attrs: {
                                                                      color:
                                                                        "primary",
                                                                      disabled:
                                                                        _vm.publishingSchedule,
                                                                      text:
                                                                        _vm
                                                                          .$vuetify
                                                                          .breakpoint
                                                                          .lgAndUp,
                                                                      icon:
                                                                        _vm
                                                                          .$vuetify
                                                                          .breakpoint
                                                                          .mdAndDown,
                                                                      title: _vm.$t(
                                                                        "labels.publishSchedule"
                                                                      )
                                                                    }
                                                                  },
                                                                  "v-btn",
                                                                  attrs,
                                                                  false
                                                                ),
                                                                Object.assign(
                                                                  {},
                                                                  tooltipOn,
                                                                  {
                                                                    click:
                                                                      _vm.publishSchedule
                                                                  }
                                                                )
                                                              ),
                                                              [
                                                                _vm.publishingSchedule
                                                                  ? _c(
                                                                      "v-progress-circular",
                                                                      {
                                                                        attrs: {
                                                                          color:
                                                                            "primary lighten-2",
                                                                          indeterminate:
                                                                            "",
                                                                          size:
                                                                            "22",
                                                                          width:
                                                                            "2"
                                                                        }
                                                                      }
                                                                    )
                                                                  : _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          size:
                                                                            "20"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                      fas fa-paper-plane\n                    "
                                                                        )
                                                                      ]
                                                                    ),
                                                                _vm.$vuetify
                                                                  .breakpoint
                                                                  .lgAndUp
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "ml-2"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                      " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "labels.publish"
                                                                              )
                                                                            ) +
                                                                            "\n                    "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    false,
                                                    3610007861
                                                  )
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "body-2" },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "labels.information"
                                                            )
                                                          ) +
                                                          "\n                "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.needsReview
                                            ? [
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: {
                                                      bottom: "",
                                                      "nudge-top": "10"
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function(ref) {
                                                            var tooltipOn =
                                                              ref.on
                                                            var attrs =
                                                              ref.attrs
                                                            return [
                                                              _c(
                                                                "v-btn",
                                                                _vm._g(
                                                                  _vm._b(
                                                                    {
                                                                      staticClass:
                                                                        "reject-schedule mr-2",
                                                                      attrs: {
                                                                        color:
                                                                          "error",
                                                                        disabled:
                                                                          _vm.approvingSchedule ||
                                                                          _vm.rejectingSchedule,
                                                                        text:
                                                                          _vm
                                                                            .$vuetify
                                                                            .breakpoint
                                                                            .lgAndUp,
                                                                        icon:
                                                                          _vm
                                                                            .$vuetify
                                                                            .breakpoint
                                                                            .mdAndDown,
                                                                        title: _vm.$t(
                                                                          "labels.reject"
                                                                        )
                                                                      }
                                                                    },
                                                                    "v-btn",
                                                                    attrs,
                                                                    false
                                                                  ),
                                                                  Object.assign(
                                                                    {},
                                                                    tooltipOn,
                                                                    {
                                                                      click:
                                                                        _vm.rejectSchedule
                                                                    }
                                                                  )
                                                                ),
                                                                [
                                                                  _vm.rejectingSchedule
                                                                    ? _c(
                                                                        "v-progress-circular",
                                                                        {
                                                                          attrs: {
                                                                            color:
                                                                              "primary lighten-2",
                                                                            indeterminate:
                                                                              "",
                                                                            size:
                                                                              "22",
                                                                            width:
                                                                              "2"
                                                                          }
                                                                        }
                                                                      )
                                                                    : _c(
                                                                        "v-icon",
                                                                        {
                                                                          attrs: {
                                                                            size:
                                                                              "20"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                        fas fa-times-circle\n                      "
                                                                          )
                                                                        ]
                                                                      ),
                                                                  _vm.$vuetify
                                                                    .breakpoint
                                                                    .lgAndUp
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "ml-2"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                        " +
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "labels.reject"
                                                                                )
                                                                              ) +
                                                                              "\n                      "
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      2584510527
                                                    )
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "body-2" },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "labels.reject"
                                                              )
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: {
                                                      bottom: "",
                                                      "nudge-top": "10"
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function(ref) {
                                                            var tooltipOn =
                                                              ref.on
                                                            var attrs =
                                                              ref.attrs
                                                            return [
                                                              _c(
                                                                "v-btn",
                                                                _vm._g(
                                                                  _vm._b(
                                                                    {
                                                                      staticClass:
                                                                        "approve-schedule",
                                                                      attrs: {
                                                                        color:
                                                                          "success",
                                                                        disabled:
                                                                          _vm.approvingSchedule ||
                                                                          _vm.rejectingSchedule,
                                                                        text:
                                                                          _vm
                                                                            .$vuetify
                                                                            .breakpoint
                                                                            .lgAndUp,
                                                                        icon:
                                                                          _vm
                                                                            .$vuetify
                                                                            .breakpoint
                                                                            .mdAndDown,
                                                                        title: _vm.$t(
                                                                          "labels.approve"
                                                                        )
                                                                      }
                                                                    },
                                                                    "v-btn",
                                                                    attrs,
                                                                    false
                                                                  ),
                                                                  Object.assign(
                                                                    {},
                                                                    tooltipOn,
                                                                    {
                                                                      click:
                                                                        _vm.approveSchedule
                                                                    }
                                                                  )
                                                                ),
                                                                [
                                                                  _vm.approvingSchedule
                                                                    ? _c(
                                                                        "v-progress-circular",
                                                                        {
                                                                          attrs: {
                                                                            color:
                                                                              "primary lighten-2",
                                                                            indeterminate:
                                                                              "",
                                                                            size:
                                                                              "22",
                                                                            width:
                                                                              "2"
                                                                          }
                                                                        }
                                                                      )
                                                                    : _c(
                                                                        "v-icon",
                                                                        {
                                                                          attrs: {
                                                                            size:
                                                                              "20"
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                        fas fa-check-circle\n                      "
                                                                          )
                                                                        ]
                                                                      ),
                                                                  _vm.$vuetify
                                                                    .breakpoint
                                                                    .lgAndUp
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "ml-2"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                        " +
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "labels.approve"
                                                                                )
                                                                              ) +
                                                                              "\n                      "
                                                                          )
                                                                        ]
                                                                      )
                                                                    : _vm._e()
                                                                ],
                                                                1
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      3031461441
                                                    )
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "body-2" },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "labels.approve"
                                                              )
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: {
                                        "align-self": "center",
                                        cols: "auto"
                                      }
                                    },
                                    [
                                      _vm.scheduleStateIndicator.stateDescKey
                                        ? _c(
                                            "v-row",
                                            {
                                              staticClass: "ml-1",
                                              attrs: { align: "center" }
                                            },
                                            [
                                              _c(
                                                "v-chip",
                                                {
                                                  class: [
                                                    "font-weight-medium ml-5 white--text",
                                                    _vm.scheduleStateIndicator
                                                      .stateLabelCssClass
                                                  ],
                                                  attrs: { small: "" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          _vm
                                                            .scheduleStateIndicator
                                                            .stateLabelKey
                                                        )
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              ),
                                              _vm.$vuetify.breakpoint.lgAndUp
                                                ? _c(
                                                    "span",
                                                    {
                                                      class: [
                                                        "caption font-weight-medium ml-3",
                                                        _vm
                                                          .scheduleStateIndicator
                                                          .stateDescCssClass
                                                      ]
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              _vm
                                                                .scheduleStateIndicator
                                                                .stateDescKey,
                                                              {
                                                                date:
                                                                  _vm
                                                                    .scheduleStateIndicator
                                                                    .date
                                                              }
                                                            )
                                                          ) +
                                                          "\n                "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _c("v-spacer"),
                                  !_vm.$vuetify.breakpoint.smAndDown
                                    ? [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "pr-0",
                                            attrs: {
                                              "align-self": "center",
                                              cols: "auto"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: {
                                                  bottom: "",
                                                  "nudge-top": "10"
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function(ref) {
                                                        var tooltipOn = ref.on
                                                        var attrs = ref.attrs
                                                        return [
                                                          _c(
                                                            "v-btn",
                                                            _vm._g(
                                                              _vm._b(
                                                                {
                                                                  staticClass:
                                                                    "mx-1",
                                                                  attrs: {
                                                                    icon: ""
                                                                  }
                                                                },
                                                                "v-btn",
                                                                attrs,
                                                                false
                                                              ),
                                                              Object.assign(
                                                                {},
                                                                tooltipOn,
                                                                {
                                                                  click:
                                                                    _vm.toggleHelpPanel
                                                                }
                                                              )
                                                            ),
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "primary"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        fal fa-info-circle\n                      "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  1846916210
                                                )
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "body-2" },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "labels.information"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            ]
                      ],
                      2
                    ),
                    _c(
                      "v-row",
                      { attrs: { justify: "end", "no-gutters": "" } },
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12" } },
                          [
                            _c(
                              "v-tabs",
                              {
                                staticClass: "job-types",
                                attrs: {
                                  "mobile-breakpoint": "768",
                                  "show-arrows": "",
                                  "slider-color": "accent",
                                  "slider-size": "3",
                                  value: _vm.selectedJobTypeTab
                                }
                              },
                              _vm._l(_vm.groupedJobTypes, function(
                                jobTypeGroup,
                                index
                              ) {
                                return _c(
                                  "v-tab",
                                  {
                                    key: index,
                                    nativeOn: {
                                      "!click": function($event) {
                                        $event.preventDefault()
                                        $event.stopPropagation()
                                        return _vm.onJobTypeChange(index)
                                      }
                                    }
                                  },
                                  [
                                    _vm._l(jobTypeGroup, function(
                                      jobType,
                                      jobIndex
                                    ) {
                                      return [
                                        jobIndex > 0
                                          ? _c(
                                              "span",
                                              {
                                                key: jobType.id + "-plus",
                                                staticClass: "ml-2"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  +\n                "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "span",
                                          {
                                            key: jobType.id + "-name",
                                            class: jobIndex > 0 ? "ml-2" : ""
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(jobType.name) +
                                                "\n                "
                                            )
                                          ]
                                        ),
                                        index > 0
                                          ? [
                                              _vm.hasValidationErrors(
                                                jobType.id
                                              )
                                                ? _c(
                                                    "v-icon",
                                                    {
                                                      key:
                                                        jobType.id +
                                                        "-validation",
                                                      staticClass:
                                                        "error--text ml-1 mr-1",
                                                      attrs: { "x-small": "" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    fas fa-exclamation-circle\n                  "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          : [
                                              _vm.hasValidationErrors()
                                                ? _c(
                                                    "v-icon",
                                                    {
                                                      key:
                                                        jobType.id +
                                                        "-validation",
                                                      staticClass:
                                                        "error--text ml-1 mr-1",
                                                      attrs: { "x-small": "" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    fas fa-exclamation-circle\n                  "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                      ]
                                    })
                                  ],
                                  2
                                )
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c("v-spacer")
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      {
                        staticClass: "grid-action-bar",
                        attrs: { justify: "center", "justify-md": "end" }
                      },
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "auto" } },
                          [
                            _c(
                              "v-menu",
                              {
                                attrs: {
                                  "min-width": "250px",
                                  "close-on-content-click": false,
                                  "offset-y": ""
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var value = ref.value
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              staticClass:
                                                "title font-weight-regular text-capitalize schedule-dropdown px-2",
                                              attrs: {
                                                color: "primary",
                                                elevation: "0",
                                                outlined: "",
                                                width: "250px"
                                              }
                                            },
                                            on
                                          ),
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "body-2 font-weight-medium"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.selectedScheduleText
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "v-icon",
                                              { attrs: { size: "20" } },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      value
                                                        ? "fas fa-caret-up"
                                                        : "fas fa-caret-down"
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ]),
                                model: {
                                  value: _vm.showSchedulePicker,
                                  callback: function($$v) {
                                    _vm.showSchedulePicker = $$v
                                  },
                                  expression: "showSchedulePicker"
                                }
                              },
                              [
                                _c("ScheduleSelection", {
                                  attrs: {
                                    department: _vm.department,
                                    "selected-schedule-id":
                                      _vm.selectedScheduleId
                                  },
                                  on: {
                                    select: _vm.setSelectedSchedule,
                                    close: function($event) {
                                      _vm.showSchedulePicker = false
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c("v-spacer"),
                        _vm.showOpenShiftToggle
                          ? _c(
                              "v-col",
                              { staticClass: "px-0", attrs: { cols: "auto" } },
                              [
                                _c(
                                  "div",
                                  {
                                    class: [
                                      "actions",
                                      _vm.$vuetify.breakpoint.smAndDown
                                        ? ""
                                        : "float-right"
                                    ]
                                  },
                                  [
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "v-badge",
                                                    {
                                                      staticClass:
                                                        "badge-panel count",
                                                      attrs: {
                                                        avatar: "",
                                                        color: "error",
                                                        content:
                                                          _vm.openShiftCount,
                                                        overlap: "",
                                                        value:
                                                          _vm.openShiftCount > 0
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              class:
                                                                _vm.actionStyles
                                                                  .viewOpenShift
                                                                  .button
                                                                  .classes,
                                                              attrs: {
                                                                icon: "",
                                                                value:
                                                                  "viewOpenShift"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.setOpenedPanelName(
                                                                    "viewOpenShift"
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              class:
                                                                _vm.actionStyles
                                                                  .viewOpenShift
                                                                  .icon.classes,
                                                              attrs: {
                                                                size: "16"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                      fal fa-list\n                    "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1024880206
                                        )
                                      },
                                      [
                                        _c("span", { staticClass: "body-2" }, [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t("labels.viewOpenShift")
                                              ) +
                                              "\n              "
                                          )
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "v-col",
                          { staticClass: "px-0", attrs: { cols: "auto" } },
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                class:
                                                  _vm.actionStyles.filters
                                                    .button.classes,
                                                attrs: {
                                                  icon: "",
                                                  value: "filters"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.setOpenedPanelName(
                                                      "filters"
                                                    )
                                                  }
                                                }
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _vm.hasFilters &&
                                            _vm.openedPanelName !== "filters"
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    class:
                                                      _vm.actionStyles.filters
                                                        .icon.classes,
                                                    attrs: { size: "16" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  fas fa-filter\n                "
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "v-icon",
                                                  {
                                                    class:
                                                      _vm.actionStyles.filters
                                                        .icon.classes,
                                                    attrs: { size: "16" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  fal fa-filter\n                "
                                                    )
                                                  ]
                                                )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ])
                              },
                              [
                                _c("span", { staticClass: "body-2" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("labels.filter")) +
                                      "\n            "
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { staticClass: "px-0", attrs: { cols: "auto" } },
                          [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                class:
                                                  _vm.actionStyles.download
                                                    .button.classes,
                                                attrs: { icon: "" },
                                                on: {
                                                  click: function($event) {
                                                    _vm.download.dialogOpened = true
                                                  }
                                                }
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                class:
                                                  _vm.actionStyles.download.icon
                                                    .classes,
                                                attrs: { size: "16" }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  fal fa-download\n                "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ])
                              },
                              [
                                _c("span", { staticClass: "body-2" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("labels.download")) +
                                      "\n            "
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("StaffSearch", {
                      attrs: {
                        "append-icon": _vm.staffFilter ? "" : "fal fa-search",
                        "target-class": "search-staff py-3 ml-4",
                        clearable: !!_vm.staffFilter,
                        dense: "",
                        disabled: _vm.hasChanges,
                        "hide-details": "",
                        "nudge-right": "100",
                        solo: "",
                        "target-style": _vm.searchStaffStyle
                      },
                      model: {
                        value: _vm.staffFilter,
                        callback: function($$v) {
                          _vm.staffFilter =
                            typeof $$v === "string" ? $$v.trim() : $$v
                        },
                        expression: "staffFilter"
                      }
                    }),
                    _c("div", {
                      ref: "gridParent",
                      staticClass: "grid-parent",
                      style: _vm.gridStyle
                    }),
                    _c("svg", { style: _vm.gridOverlayStyle }, [
                      _c("polygon", {
                        staticStyle: {
                          "fill-opacity": "0.05",
                          stroke: "transparent",
                          "stroke-width": "0"
                        },
                        attrs: { points: _vm.gridOverlayPath }
                      })
                    ])
                  ],
                  1
                ),
                _vm.$vuetify.breakpoint.smAndDown
                  ? [
                      _c(
                        "v-btn",
                        {
                          class: [
                            "elevation-0 schedule-summary-row-toggle",
                            { active: _vm.mobileSummaryRow }
                          ],
                          style: {
                            bottom: _vm.mobileSummaryRow
                              ? _vm.footerHeight + 54 + "px"
                              : "54px"
                          },
                          attrs: { fixed: "", ripple: false, small: "" },
                          on: {
                            click: function($event) {
                              _vm.mobileSummaryRow = !_vm.mobileSummaryRow
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { color: "error", "x-small": "" } },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.mobileSummaryRow
                                      ? "far fa-chevron-down"
                                      : "far fa-chevron-up"
                                  ) +
                                  "\n        "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-footer",
                        {
                          staticClass: "elevation-0 schedule-summary-row pb-0",
                          style: {
                            bottom: _vm.mobileSummaryRow
                              ? "56px"
                              : 56 - _vm.footerHeight + "px"
                          },
                          attrs: { fixed: "" }
                        },
                        _vm._l(_vm.validators, function(validator) {
                          return _c(
                            "v-btn",
                            {
                              key: "tab" + _vm.getValidatorName(validator),
                              staticClass:
                                "mx-2 mb-2 caption font-weight-medium text-capitalize",
                              attrs: { depressed: "" },
                              on: {
                                click: function($event) {
                                  return _vm.showErrorsOverview(validator)
                                }
                              }
                            },
                            [
                              _c(
                                "v-chip",
                                {
                                  staticClass: "mr-2 px-2 white--text",
                                  attrs: {
                                    color:
                                      _vm.getValidatorErrorCount(validator) > 0
                                        ? "error"
                                        : "primary lighten-2",
                                    label: "",
                                    "x-small": ""
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.showErrorsOverview(validator)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.getValidatorErrorCount(validator)
                                      ) +
                                      "\n          "
                                  )
                                ]
                              ),
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "labels." +
                                        _vm.getValidatorName(validator)
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _c(
                                "v-icon",
                                {
                                  staticClass: "pl-2 grey--text text--darken-1",
                                  style: {
                                    visibility: _vm.hasTabFilters
                                      ? "visible"
                                      : "hidden"
                                  },
                                  attrs: { "x-small": "" }
                                },
                                [
                                  _vm._v(
                                    "\n            fas fa-filter\n          "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ]
                  : _c(
                      "v-footer",
                      {
                        staticClass: "schedule-summary-row pr-8 pb-0",
                        style: _vm.summaryRowStyle,
                        attrs: { fixed: "" }
                      },
                      [
                        _vm._l(_vm.validators, function(validator) {
                          return _c(
                            "v-btn",
                            {
                              key: "tab" + _vm.getValidatorName(validator),
                              staticClass:
                                "mx-2 caption font-weight-medium text-capitalize mb-2",
                              attrs: { depressed: "" },
                              on: {
                                click: function($event) {
                                  return _vm.showErrorsOverview(validator)
                                }
                              }
                            },
                            [
                              _c(
                                "v-chip",
                                {
                                  staticClass: "mr-2 px-2 white--text",
                                  attrs: {
                                    color:
                                      _vm.getValidatorErrorCount(validator) > 0
                                        ? "error"
                                        : "primary lighten-2",
                                    label: "",
                                    "x-small": ""
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.showErrorsOverview(validator)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.getValidatorErrorCount(validator)
                                      ) +
                                      "\n        "
                                  )
                                ]
                              ),
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    _vm.$t(
                                      "labels." +
                                        _vm.getValidatorName(validator)
                                    )
                                  ) +
                                  "\n        "
                              ),
                              _c(
                                "v-icon",
                                {
                                  staticClass: "pl-2 grey--text text--darken-1",
                                  style: {
                                    visibility: _vm.hasTabFilters
                                      ? "visible"
                                      : "hidden"
                                  },
                                  attrs: { "x-small": "" }
                                },
                                [_vm._v("\n          fas fa-filter\n        ")]
                              )
                            ],
                            1
                          )
                        }),
                        _c("v-spacer")
                      ],
                      2
                    ),
                _c(
                  "v-dialog",
                  {
                    attrs: { eager: "", persistent: "", fullscreen: "" },
                    model: {
                      value: _vm.download.dialogOpened,
                      callback: function($$v) {
                        _vm.$set(_vm.download, "dialogOpened", $$v)
                      },
                      expression: "download.dialogOpened"
                    }
                  },
                  [
                    _c(
                      "v-card",
                      { attrs: { id: "downloadMasterSchedule" } },
                      [
                        _c(
                          "v-card-title",
                          { staticClass: "body-2 d-block mb-2" },
                          [
                            _c(
                              "span",
                              { staticClass: "body-2 font-weight-medium" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("labels.downloadMasterSchedule")
                                    ) +
                                    "\n          "
                                )
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "body-2 font-weight-medium primary--text"
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.selectedScheduleText) +
                                    "\n          "
                                )
                              ]
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "float-right mt-n1",
                                attrs: { icon: "", small: "" },
                                on: {
                                  click: function($event) {
                                    _vm.download.dialogOpened = false
                                  }
                                }
                              },
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v(
                                    "\n              fal fa-times\n            "
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card-text",
                          {
                            staticClass: "pa-0 ma-0",
                            style: _vm.downloadGridContainerStyle
                          },
                          [
                            _c("div", {
                              ref: "downloadGrid",
                              staticClass: "download-grid",
                              style: _vm.downloadGridStyle
                            })
                          ]
                        ),
                        _c(
                          "v-footer",
                          {
                            attrs: { color: "white", fixed: "", height: "75px" }
                          },
                          [
                            _c("v-select", {
                              staticStyle: { "max-width": "184px" },
                              attrs: {
                                dense: "",
                                "hide-details": "",
                                items: [
                                  {
                                    text: _vm.$t("labels.letter"),
                                    value: "LETTER"
                                  },
                                  {
                                    text: _vm.$t("labels.legal"),
                                    value: "LEGAL"
                                  }
                                ],
                                label: _vm.$t("labels.pageSize"),
                                outlined: ""
                              },
                              model: {
                                value: _vm.download.pageSize,
                                callback: function($$v) {
                                  _vm.$set(_vm.download, "pageSize", $$v)
                                },
                                expression: "download.pageSize"
                              }
                            }),
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { text: "" },
                                on: {
                                  click: function($event) {
                                    _vm.download.dialogOpened = false
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("labels.cancel")) +
                                    "\n          "
                                )
                              ]
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "start-download",
                                attrs: { color: "secondary" },
                                on: { click: _vm.downloadSchedule }
                              },
                              [
                                _vm.download.inProgress
                                  ? _c("v-progress-circular", {
                                      staticClass: "px-12",
                                      attrs: {
                                        color: "white",
                                        indeterminate: "",
                                        size: "22",
                                        width: "2"
                                      }
                                    })
                                  : _c("span", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("labels.downloadPDF")) +
                                          "\n            "
                                      )
                                    ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("SidePanel", {
                  attrs: { panels: _vm.sidePanels },
                  on: {
                    transitionend: function($event) {
                      return _vm.redrawGrid(true)
                    }
                  }
                }),
                _vm.nurseDetails
                  ? _c("UserDialog", {
                      attrs: {
                        "show-hint": false,
                        user: Object.assign({}, _vm.nurseDetails)
                      },
                      on: {
                        close: _vm.hideNurseDetails,
                        saved: _vm.updateNurseDetails
                      }
                    })
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }